import apiService from './apiService';
import { API_ENDPOINTS, API_CONFIG } from '../constants/apiConstants';

export const orderAPI = {
  getAllOrders: async (params: { page?: number; limit?: number; status?: string; orderStatus?: string }) => {
    const queryParams = {
      page: params.page,
      limit: params.limit,
      orderStatus: params.status || params.orderStatus
    };
    const response = await apiService.get(API_ENDPOINTS.ORDER.GET_ALL, { params: queryParams });
    return response.data;
  },
  getOrderById: async (id: string) => {
    const response = await apiService.get(`${API_ENDPOINTS.ORDER.GET_BY_ID}/${id}`);
    return response.data;
  },
  updateOrderStatus: async (id: string, status: string) => {
    const response = await apiService.patch(`${API_ENDPOINTS.ORDER.UPDATE}/${id}`, { orderStatus: status });
    return response.data;
  },
  downloadCSV: async (params: { status?: string; fromDate?: string; toDate?: string }) => {
    const queryParams = {
      csv: 'true',
      orderStatus: params.status,
      fromDate: params.fromDate,
      toDate: params.toDate
    };
    const response = await apiService.get(API_ENDPOINTS.ORDER.GET_ALL, { 
      params: queryParams,
      responseType: 'blob'
    });
    return response;
  },
};